module.exports = __webpack_public_path__ + "img/active-item-bgimg.8ffce45c.png";